import React, { useEffect, useState } from 'react';
import Collapsible from 'react-collapsible';
import './Accordion.scss';
import MenuChevron from './Micro/MenuChevron';
import parse from 'html-react-parser';

export const Accordion = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const data = props.data || {};
  const resourcesItems = data.items;
  const handleClick = (item) => {
    props.renderBackArrowTemplate(item);
  };
  return (
    <Collapsible
      trigger={
        <div>
          <div id={props.id}></div>
          <div className="flex w-full justify-between ">
            <p className="dropdown-text">{data.label}</p>
            <MenuChevron isOpen={data.id === props.currentAccordianId} />
          </div>
        </div>
      }
      open={data.id === props.currentAccordianId}
      handleTriggerClick={(accordianPosition) => {
        // window.scrollTo({top:0, behavior:'smooth'});
        // console.log(accordianPosition,document.body.scrollTop,document.documentElement.scrollTop, "accordianPosition")
        // document.body.scrollTop = 0;
        // document.documentElement.scrollTop = 0;
        // props.setCurrentAccordianId('our-ecosystem');
        if (props.currentAccordianId === accordianPosition) {
          props.setCurrentAccordianId('');
        } else {
          props.setCurrentAccordianId(accordianPosition);
        }
      }}
      overflowWhenOpen="visible"
      transitionTime={100}
      accordionPosition={data.id}
      // onOpen={props.handleClickToTop}
    >
      <section>
        {data.left_column_title !== '' &&
          parse(data.left_column_description) !== '' && (
            <section className="left-section-tab">
              <p className="left-section-title">{data.left_column_title}</p>
              <p className="left-section-description">
                {parse(data.left_column_description)}
              </p>
              {data?.left_column_cta_url !== '' &&
                data?.left_column_cta_url !== undefined &&
                data?.left_column_cta_url !== null &&
                data?.left_column_cta_title !== '' &&
                data?.left_column_cta_title !== undefined && (
                  <a
                    rel="noreferrer"
                    href={data?.left_column_cta_url}
                    target={data?.isExternal == '0' ? '_self' : '_blank'}
                  >
                    <div className="left-section-cta">
                      <span className="cta-text">
                        {data.left_column_cta_title}
                      </span>
                    </div>
                  </a>
                )}
            </section>
          )}
      </section>
      {resourcesItems !== undefined && data.template_type == 'link_and_cta' && (
        <ul className="bg-color">
          {resourcesItems?.map((item, index) => (
            <li key={index}>
              <div className="section-line"></div>
              <div
                className="col-desc-item"
                style={{
                  padding: '16px 12px 16px 24px !important',
                  width: '100%',
                }}
                role="button"
                tabIndex={0}
                onClick={() => handleClick(item)}
              >
                <section className="flex navigate-section">
                  <section className="flex navigate-item">
                    <p className="main-item-title">{item.label}</p>
                    <p className="main-item-desc">{item.description}</p>
                  </section>
                  <section>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m10 7.496 4.297 4.252L10 16"
                        stroke="#343741"
                        strokeWidth="1.507"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </section>
                </section>
              </div>
            </li>
          ))}
        </ul>
      )}
      {resourcesItems !== undefined &&
        data.template_type == 'with_right_section_text_only' && (
          <section>
            <ul className="bg-color">
              {resourcesItems.map((item, index) => (
                <li key={index}>
                  <div className="section-line"></div>
                  <a
                    href={item.url}
                    className="col-description-item"
                    target={item?.isExternal == '0' ? '_self' : '_blank'}
                    rel="noreferrer"
                  >
                    <section className="flex navigate-section">
                      <section className="flex navigate-item">
                        {item.field_link_tag ? (
                          <div className="flex">
                            <p className="main-item-title main-item-title-flex main-item-title-mid">
                              {item.label}
                            </p>
                            <div
                              className="main-tag-name"
                              style={{
                                backgroundColor: `${item.field_tag_bg_color}`,
                              }}
                            >
                              {item.field_link_tag}
                            </div>
                          </div>
                        ) : (
                          <p className="main-item-title">{item.label}</p>
                        )}

                        {/* <p className='item-title'>{mainItem.label}</p> */}
                        <p className="main-item-desc">{item.description}</p>
                      </section>
                    </section>
                  </a>
                </li>
              ))}
            </ul>
            <ul className="bg-color-dark" style={{ paddingBottom: '16px' }}>
              <li>
                {/* <div className='section-line'></div> */}
                <section
                  className="col-desc-item col-offerings-item"
                  style={{ cursor: 'default !important' }}
                >
                  <section
                    className="flex navigate-section"
                    style={{
                      paddingLeft: '24px !important',
                      margin: '0px',
                      paddingBottom: '16px',
                    }}
                  >
                    <section className="flex navigate-item">
                      <p className="offerings-title">
                        {data.right_section_heading}
                      </p>

                      {/* <p className='item-title'>{mainItem.label}</p> */}
                      <p className="main-item-desc">
                        {parse(data.right_section_description)}
                      </p>
                    </section>
                  </section>
                </section>
              </li>
              {data.right_section.length > 0 &&
                data.right_section.map((item, index) => (
                  <li key={index}>
                    <div className="section-line-additional"></div>
                    {/* <a href={item?.field_cta_url}
                    target={item.isExternal == '0' ? '_self' : '_blank'} className="col-desc-item"> */}
                    <div className="col-desc-item col-desc-item1">
                      <a
                        href={item?.field_cta_url}
                        // target={item.isExternal == '0' ? '_self' : '_blank'}
                        rel="noreferrer"
                      >
                        <section className="flex navigate-section-additional">
                          <section className="flex navigate-item">
                            {item.field_link_tag ? (
                              <div className="flex">
                                <p
                                  className="main-item-title main-item-title-flex"
                                  style={{
                                    marginTop: '4px',
                                    marginBottom: '4px',
                                  }}
                                >
                                  {item.title}
                                </p>
                                <div
                                  className="main-tag-name"
                                  style={{
                                    backgroundColor: `${item.field_tag_bg_color}`,
                                  }}
                                >
                                  {item.field_link_tag}
                                </div>
                              </div>
                            ) : (
                              <p className="main-item-title">{item.title}</p>
                            )}

                            {/* <p className='item-title'>{mainItem.label}</p> */}
                            <p className="main-item-desc">{item.description}</p>
                          </section>
                        </section>
                      </a>
                    </div>
                    {/* </a> */}
                  </li>
                ))}
            </ul>
          </section>
        )}
      {resourcesItems !== undefined &&
        data.template_type == 'with_right_section_image_horizontal' && (
          <ul className="bg-color">
            {resourcesItems.map((item, index) => (
              <li key={index}>
                <div className="section-line"></div>
                <a
                  href={item.url}
                  className="col-desc-item"
                  target={item.isExternal == '0' ? '_self' : '_blank'}
                  rel="noreferrer"
                >
                  <section className="flex navigate-section">
                    <section className="flex navigate-item">
                      {item.field_link_tag ? (
                        <div className="flex flex-items">
                          <p
                            className="main-item-title main-item-title-flex"
                            style={{ marginTop: '4px', marginBottom: '4px' }}
                          >
                            {item.label}
                          </p>
                          <div
                            className="main-tag-name"
                            style={{
                              backgroundColor: `${item.field_tag_bg_color}`,
                            }}
                          >
                            {item.field_link_tag}
                          </div>
                        </div>
                      ) : (
                        <p className="main-item-title">{item.label}</p>
                      )}

                      {/* <p className='item-title'>{mainItem.label}</p> */}
                      <p className="main-item-desc">{item.description}</p>
                    </section>
                  </section>
                </a>
              </li>
            ))}
            {data.right_section.map((item, index) => (
              <li key={index}>
                <div className="section-line"></div>
                <a
                  href={item.field_cta_url}
                  className="col-desc-item"
                  // target={item.isExternal == '0' ? '_self' : '_blank'}
                  rel="noreferrer"
                >
                  <section className="image-section-additional">
                    <img
                      src={item.field_card_image}
                      alt="image"
                      className="inner-image"
                    ></img>
                  </section>
                  <section className="flex navigate-section">
                    <section className="flex navigate-item">
                      {item.field_link_tag ? (
                        <div className="flex flex-items">
                          <p
                            className="main-item-title main-item-title-flex"
                            style={{ marginTop: '4px', marginBottom: '4px' }}
                          >
                            {item.title}
                          </p>
                          <div
                            className="main-tag-name"
                            style={{
                              backgroundColor: `${item.field_tag_bg_color}`,
                            }}
                          >
                            {item.field_link_tag}
                          </div>
                        </div>
                      ) : (
                        <p className="main-item-title">{item.title}</p>
                      )}
                      <p className="main-item-desc">{item.description}</p>
                    </section>
                  </section>
                </a>
              </li>
            ))}
          </ul>
        )}
    </Collapsible>
  );
};
